import { ApplicationUpdatesEffects } from './application-updates/application-updates.effects';
import { FilterEventTrackingEffects } from './filter-event-tracking.effects';
import { LogEffects } from './log.effects';
import { MonitoringEffects } from './monitoring/monitoring.effects';
import { UserflowEffects } from './userflow/userflow.effects';
import { FeatureFlagsEffects } from './feature-flags/feature-flags.effects';
import { ChatInitEffects } from './initialization/chat-init.effects';
import { UserEventsEffects } from './user-events/user-events.effects';
import { AmplitudeInitEffects } from './initialization/amplitude-init.effects';
import { PusherInitEffects } from './initialization/pusher-init.effects';
import { SurveyInitEffects } from './initialization/survey-init.effects';

export const effects = [
  FilterEventTrackingEffects,
  LogEffects,
  MonitoringEffects,
  UserflowEffects,
  ApplicationUpdatesEffects,
  FeatureFlagsEffects,
  ChatInitEffects,
  UserEventsEffects,
  AmplitudeInitEffects,
  PusherInitEffects,
  SurveyInitEffects
];
